import { PromoComponent } from '@/mainComponent/PromoComponent';
import { ACTION } from '@/store/ACTION';

class ShowStartPromo {
  protected allowed(): boolean {
    const isStartedGames: boolean =
      this.store.gameData.freeSpinsGame.isPlaying() ||
      this.store.gameData.freeSpinsGame.isStarted() ||
      this.store.gameData.bonusGame.isPlaying() ||
      this.store.gameData.bonusGame.isStarted();
    return (
      this.store.promo.hasPromoApp() &&
      !this.store.promo.isFinishedPrizeGame &&
      (this.store.promo.isTournament ||
        this.store.promo.isAchievement ||
        this.store.promo.isAchievementBG ||
        this.store.promo.isAchievementFS) &&
      !isStartedGames &&
      !this.store.promo.isFreeRounds
    );
  }

  execution(): void {
    if (!this.allowed()) return;

    const { freeSpinsWinInOtherGame, freeSpinsWin, isPrizeGameWin, isPrizeGameWinOtherGame } = this.store.promo;
    switch (true) {
      case freeSpinsWinInOtherGame || isPrizeGameWinOtherGame:
        promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_WIN_OTHER_GAME);
        this.store.promo.isShowPopupFreeSpinsOtherGameAchievement = true;
        break;
      case freeSpinsWin:
        promoApp.eventEmitter.emit(ACTION.SHOW_FREESPIN_WIN);
        promoApp.eventEmitter.emit(ACTION.SHOW_PROGRESS_BAR);
        game.emit(PromoComponent.events.START_FREESPINS);
        break;
      case isPrizeGameWin:
        promoApp.eventEmitter.emit(ACTION.SHOW_PRIZE_GAME_WIN);
        game.emit(PromoComponent.events.START_FREESPINS);
        break;
      default:
        if (
          !this.store.promo.isFreeRounds &&
          !this.store.promo.isFreeSpinsTournament &&
          !this.store.promo.isStartTournament
        ) {
          this.store.promo.isStartTournament = true;
          promoApp.eventEmitter.emit(ACTION.SHOW_WELCOME_POPUP);
        }
        if (this.store.promo.isAchievement || this.store.promo.isAchievementBG || this.store.promo.isAchievementFS) {
          promoApp.eventEmitter.emit(ACTION.SHOW_PROGRESS_BAR);
        }
    }
    promoApp.eventEmitter.emit(ACTION.SHOW_PANEL_ICON);
    this.store.promo.isStartedPromo = true;
    if (this.store.promo.isAchievement || this.store.promo.isAchievementBG || this.store.promo.isAchievementFS) {
      if (!this.store.promo.isStartAchievement) {
        game.emit(PromoComponent.events.START_ACHIEVEMENT);
      }
      this.store.promo.isStartAchievement = true;
    } else game.emit(PromoComponent.events.START_TOURNAMENT);
  }

  get store() {
    return game.store;
  }
}

export { ShowStartPromo };
